import type { DuplicateGroup, MergeChoice } from './types';

function distinct(values: (string | undefined)[]): string[] {
  return [...new Set(values.filter((value): value is string => !!value))];
}

/* The titles a group's listings carry, each once. */
export function titleOptions(group: DuplicateGroup): string[] {
  return distinct((group.items ?? []).map(item => item.title));
}

/* The SKUs a group's listings carry, each once. */
export function skuOptions(group: DuplicateGroup): string[] {
  return distinct((group.items ?? []).map(item => item.sku));
}

function descriptionFor(group: DuplicateGroup, sku: string | undefined) {
  return (group.items ?? []).find(item => item.p_sku === sku)?.description;
}

/* A field with only one value to pick starts picked. */
export function defaultChoice(group: DuplicateGroup): MergeChoice {
  const titles = titleOptions(group);
  const skus = skuOptions(group);
  const choice: MergeChoice = {
    item_id: group._id,
    p_description: descriptionFor(group, group.p_sku),
  };

  if (skus.length === 1) choice.p_sku = skus[0];
  if (titles.length === 1) choice.p_title = titles[0];

  return choice;
}

/* Picking a SKU brings the description of the listing it came from. */
export function chooseField(
  group: DuplicateGroup,
  choice: MergeChoice,
  field: 'p_sku' | 'p_title',
  value: string,
): MergeChoice {
  return field === 'p_sku'
    ? { ...choice, p_sku: value, p_description: descriptionFor(group, value) }
    : { ...choice, p_title: value };
}

export function canMerge(choice: MergeChoice | undefined): boolean {
  return !!choice?.p_sku && !!choice?.p_title;
}
